import type { SVGProps } from "react";

/**
 * volume-full-fill, speaker, loud, sound, audio
 * @category Sound & Music
 */
export default function IconVolumeFullFill(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M18.3639 4.22258C18.7545 3.83206 19.3876 3.83206 19.7782 4.22258C21.7677 6.21209 23 8.96347 23 12.0008C23 15.038 21.7677 17.7894 19.7782 19.7789C19.3876 20.1695 18.7545 20.1695 18.3639 19.7789C17.9734 19.3884 17.9734 18.7552 18.3639 18.3647C19.9937 16.7349 21 14.4863 21 12.0008C21 9.5152 19.9937 7.26657 18.3639 5.63679C17.9734 5.24627 17.9734 4.61311 18.3639 4.22258Z'
        fill='currentColor'
      />
      <path
        d='M16.5963 7.40422C16.2057 7.0137 15.5726 7.0137 15.1821 7.40422C14.7915 7.79475 14.7915 8.42791 15.1821 8.81843C15.9975 9.63387 16.5001 10.7575 16.5001 12.0004C16.5001 13.2433 15.9975 14.367 15.1821 15.1824C14.7915 15.5729 14.7915 16.2061 15.1821 16.5966C15.5726 16.9871 16.2057 16.9871 16.5963 16.5966C17.7714 15.4214 18.5001 13.7951 18.5001 12.0004C18.5001 10.2058 17.7714 8.5794 16.5963 7.40422Z'
        fill='currentColor'
      />
      <path
        d='M13 4.50004C13 3.26397 11.5889 2.5584 10.6 3.30004L5.93333 6.80004C5.76024 6.92986 5.5497 7.00004 5.33333 7.00004H4C2.34315 7.00004 1 8.34318 1 10V14C1 15.6569 2.34315 17 4 17H5.33333C5.5497 17 5.76024 17.0702 5.93333 17.2L10.6 20.7C11.5889 21.4417 13 20.7361 13 19.5V4.50004Z'
        fill='currentColor'
      />
    </svg>
  );
}
